import { render, staticRenderFns } from "./TweetsFeature.vue?vue&type=template&id=dc490112&scoped=true&"
import script from "./TweetsFeature.vue?vue&type=script&lang=js&"
export * from "./TweetsFeature.vue?vue&type=script&lang=js&"
import style0 from "./TweetsFeature.vue?vue&type=style&index=0&id=dc490112&lang=scss&scoped=true&"
import style1 from "./TweetsFeature.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc490112",
  null
  
)

export default component.exports